import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";
import { Link } from "react-router-dom";

function About() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="about-page">
      <Header />

      <div className="about__wrap container">
        <nav className="breadcrumb">
          <Link onClick={toTop} to="/">Home</Link>
          <span className="crumb-sep">&lt;</span>
          <Link onClick={toTop} to="/about">About</Link>
          <span className="crumb-sep">&lt;</span>
          <span>Nicolai</span>
        </nav>

        <header className="about__hero">
          <h1 className="about__title">Our Factory</h1>
          <hr className="about__rule" />
          <p className="about__lead">
            At our Nicolai factory in Portland, Oregon, we design and craft
            high-quality lighting, hardware and fixtures by hand. Our team
            combines traditional metalworking and woodworking techniques with
            modern finishes to create durable pieces made to last.
          </p>
        </header>

        <section className="about__content">
          <div className="about__main">
            <h2>Handcrafted in Portland</h2>
            <p>
              Our specialist craftsmen finish and assemble each product with
              care. From metal polishing to hand-applied patinas, every step is
              performed to exacting standards so each piece meets our quality
              bar and your expectations.
            </p>

            <h3>What We Make</h3>
            <p>
              We produce lighting, cabinet hardware and architectural fittings,
              along with services for custom and renovation projects. Our
              workshop supports both small-batch runs and large commercial
              orders.
            </p>

            <h3>Quality &amp; Sustainability</h3>
            <p>
              We prioritize durable materials, responsible sourcing, and
              processes that reduce waste. Parts are inspected at every stage,
              and finishes are tested for longevity.
            </p>

            <h3>Visit &amp; Contact</h3>
            <p>
              To speak with our team about a project or factory tour,
              contact our customer service at <a href="tel:8884011900">888-401-1900</a> or visit your local store.
            </p>
          </div>

          <aside className="about__aside">
            <div className="about__panel">
              <h4>Factory Hours</h4>
              <p>Mon–Fri: 9:00am – 5:00pm</p>
              <h4>Address</h4>
              <p>2550 NW Nicolai St<br/>Portland, OR 97210</p>
            </div>
          </aside>
        </section>

        <section className="about__gallery">
          <div className="about__gallery-grid">
            <div className="about__img" style={{backgroundImage:`url(${process.env.PUBLIC_URL || ""}/main/main9-1.jpg)`}}/>
            <div className="about__img" style={{backgroundImage:`url(${process.env.PUBLIC_URL || ""}/main/main9-2.jpg)`}}/>
            <div className="about__img" style={{backgroundImage:`url(${process.env.PUBLIC_URL || ""}/main/main9-3.jpg)`}}/>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}

export default About;
